import { Component, effect, inject, input, Signal, signal } from '@angular/core';
// import { todoResource } from '../../todo-resource';
import { IUserRole, Role, UserRole } from '../../../../models/models.lib';
import { httpResource } from '@angular/common/http';
import { environment } from "../../../../../environments/environment";
import { CommonModule } from '@angular/common';
import { RolesList, RoleInterface } from '../../todo-interface';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TodoService } from '../../todo-service';
import { LoggerService } from '../../../../shared/logger.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogsModule, WindowModule } from '@progress/kendo-angular-dialog';
import { PagerModule } from '@progress/kendo-angular-pager';
import { GridModule } from '@progress/kendo-angular-grid';
import { MulticheckFilterComponent } from '../../../../filters/multicheck-filter/multicheck-filter.component';
import { RolePermissionComponent } from '../../../../admin/roles/role-permission/role-permission.component';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { ToastrService } from 'ngx-toastr';
import { CompositeFilterDescriptor, distinct, filterBy, orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { SettingsService } from '../../../../settings/settings.service';

const { apiUrl } = environment;

@Component({
  selector: 'casi-todo-component',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    InputsModule,
    ButtonsModule,
    DialogsModule,
    WindowModule,
    PagerModule,
    GridModule,
    MulticheckFilterComponent,
    RolePermissionComponent
  ],
  templateUrl: './todo-component.html',
  styleUrl: './todo-component.scss'
})
export class TodoComponent {
  readonly userId = input.required<string>();

  readonly todoService = inject(TodoService);
  readonly rResource = this.todoService.createRoleResource2(this.userId);
  readonly rolesResource = this.todoService.createRolesResource();

  readonly testFlag = this.todoService.testFlag;

  public filter: CompositeFilterDescriptor = { logic: "and", filters: [] };

  todos: RoleInterface[] = [];
  userRoles = signal<IUserRole[]>([]);
  rawData = signal<Role[]>([]);
  gridData = signal<Role[]>(filterBy(this.rawData(), this.filter));

  public pageSize = 10;

  private cnt = 0;

  // userRoles:IUserRole[] = [];
  readonly roleResource = httpResource<RoleInterface[]>(() => `${apiUrl}/findroles`)

  public sort: SortDescriptor[] = [
    {
      field: "name",
      dir: "asc",
    },
  ];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private toastr: ToastrService,
    public settings: SettingsService

  ) {
    faIcons.addIcons(...all);

    effect(() => {
      this.logger.debug(`constructor:effect fired....`);
      this.todos = this.roleResource.value() ?? [];
      // this.userRoles = this.rResource.value() ?? [];
      this.userRoles.set(this.rResource.value() ?? []);
      this.rawData.set(this.rolesResource.value() ?? []);
      console.log(`roles: `, this.todos);
      console.log(`user roles: `, this.userRoles());
      this.logger.debug(`userRoles:status: `, this.rResource.status());
      this.logger.debug(`rawData: `, this.rawData());
      // this.testFlag = this.todoService.testFlag();
      this.loadData();
    })
  }

  //#region Grid function

  public sortChange(sort: SortDescriptor[]): void {
    this.logger.debug("sortChange: ", sort);
    this.sort = sort;
    this.loadData();
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    // this.logger.debug('filterChange: filter: ', filter);
    this.filter = filter;
    this.loadData();
  }

  public distinctPrimitive(fieldName: string): any[] {
    this.logger.debug('distinctPrimitive: fieldName: ', fieldName);
    return distinct(this.rawData(), fieldName).map((item: any) => item[fieldName]).filter(v => v !== null && v !== undefined && v !== '');
  }

  //#endregion

  //#region Public functions

  public refreshSettings(): void {
    this.logger.debug(`refreshSettings...`);
    this.settings.refreshVariables();
  }
  public onAddRole(): void {
    this.logger.debug("onAddRole...");
  }

  onEditClick(dataItem: any): void {
    this.logger.debug("onEditClick: ", dataItem);
  }

  onEditPermisions(dataItem: any): void {
    this.logger.debug("onEditPermisions: ", dataItem);
  }

  onConfirmDelete(dataItem: any): void {
    this.logger.debug("onConfirmDelete: ", dataItem);
  }

  //#endregion

  //#region Private function

  private loadData(): void {
    this.logger.debug('loadData...');
    this.gridData.set(orderBy(filterBy(this.rawData(), this.filter), this.sort));
    this.logger.debug('loadData: gridData: ', this.gridData());
    this.pageSize = this.gridData().length;
  }

  private notify(msg: string, error: boolean = false): void {
    this.logger.debug("notify", msg);
    if (error)
      this.toastr.error(msg);
    else
      this.toastr.success(msg);
  }

  //#endregion

}
